// 引入cookie-js
import Cookie from 'js-cookie'

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    component: resolve => require(['@/views/index'], resolve)
  },
  {
    // 微信朋友圈/好友分享落地页：自动取 share_code + 手机号一键登录注册 + APP 下载引导
    path: '/download',
    meta: {
      title: '伊颂下载'
    },
    component: resolve => require(['@/views/download'], resolve)
  },
  {
    path: '/manage/',
    meta: {
      requireAuth: true,
    },
    component: resolve => require(['@/views/manage/'], resolve),
    children: [{
        path: '/manage/',
        meta: {
          title: '管理后台',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/home'], resolve)
      }, {
        path: '/manage/home',
        meta: {
          title: '数据概览',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/home'], resolve)
      }, {
        path: '/manage/admin/lists',
        meta: {
          title: '管理人员',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/lists'], resolve)
      }, {
        path: '/manage/admin/group',
        meta: {
          title: '管理角色',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/group'], resolve)
      }, {
        path: '/manage/admin/menu',
        meta: {
          title: '管理权限',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/menu'], resolve)
      }, {
        path: '/manage/admin/organization',
        meta: {
          title: '组织部门',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/organization'], resolve)
      }, {
        path: '/manage/admin/log',
        meta: {
          title: '系统日志',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/log'], resolve)
      }, {
        path: '/manage/user/lists',
        meta: {
          title: '用户列表',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/user/lists'], resolve)
      }, {
        path: '/manage/payment/vip',
        meta: {
          title: '会员订单',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/payment/vip'], resolve)
      }, {
        path: '/manage/payment/credits',
        meta: {
          title: '红豆订单',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/payment/credits'], resolve)
      }, {
        path: '/manage/setting/about',
        meta: {
          title: '关于我们',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/setting/about'], resolve)
      }
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  // base 与 publicPath 解耦：站点挂载在域名根目录，深链(如 /download)依赖此设置
  base: '/',
  routes
})

// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth == true) { // 判断该路由是否需要登录权限
    let admin = Cookie.get('admin')
    if (admin === undefined || admin === 'e30=' || !admin) { // cookie是否存在
      next({
        path: '/' // 跳转到登录界面
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
